import { createFromValidationResolver } from '@cp/utils/form';
import { PromoCodeFormModel } from './model';

export const promoFormResolver = createFromValidationResolver(PromoCodeFormModel);
